import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS, KAZAPLAN_STORAGE_KEY } from '@adeo/ngx-kozikaza-api';
import * as i3 from 'ngx-cookie';

class KazaPlanService extends BaseService {
    platformId;
    cookiesService;
    kazaPlanStorageKey;
    endpointPlans = `${this.options.API_KAZAPLAN_V41}/plans`;
    endpointProjects = `${this.endpointPlans}/projects`;
    endpointQueryParams = `${this.endpointPlans}/query-params`;
    endpointMyPlans = `${this.endpointPlans}/me`;
    endpointMediaPlans = `${this.options.API_KAZAPLAN_V41}/medias/plans`;
    endpointMedia = `${this.options.API_KAZAPLAN_V41}/medias`;
    getWebServiceName() {
        return "KazaPlanWebService";
    }
    constructor(options, httpClient, platformId, cache, logger, cookiesService, kazaPlanStorageKey) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.cookiesService = cookiesService;
        this.kazaPlanStorageKey = kazaPlanStorageKey;
    }
    // Generic method to handle GET requests
    makeGetRequest(url, params) {
        const headers = this.getHeaders();
        // If headers exist, include them; otherwise, don't pass headers at all
        const options = headers ? { headers, params } : { params };
        return this.httpClient.get(url, options);
    }
    // Generic method to handle POST requests
    makePostRequest(url, body) {
        const headers = this.getHeaders();
        // Conditionally add headers if they exist
        return headers
            ? this.httpClient.post(url, body, { headers })
            : this.httpClient.post(url, body);
    }
    // Generic method to handle PATCH requests
    makePatchRequest(url, body) {
        const headers = this.getHeaders();
        // Conditionally add headers if they exist
        return headers
            ? this.httpClient.patch(url, body, { headers })
            : this.httpClient.patch(url, body);
    }
    // Generic method to handle DELETE requests
    makeDeleteRequest(url) {
        const headers = this.getHeaders();
        // Conditionally add headers if they exist
        return headers
            ? this.httpClient.delete(url, { headers })
            : this.httpClient.delete(url);
    }
    getHeaders() {
        const bearerToken = this.cookiesService.get(`${this.kazaPlanStorageKey}_accessToken`);
        // If no bearer token, return null (meaning no headers)
        if (!bearerToken || bearerToken === 'undefined') {
            return null;
        }
        // Otherwise, return headers with Authorization
        return new HttpHeaders({
            Authorization: `Bearer ${bearerToken}`,
        });
    }
    // Specific service methods using the generic request methods
    getPlansByProjects(projectId, userId, options) {
        const params = new HttpParams()
            .set("page", options.page.toString())
            .set("pageSize", options.pageSize.toString());
        const url = `${this.endpointProjects}/${projectId}/${userId}`;
        return this.makeGetRequest(url, params);
    }
    getMyPlans(page, pageSize, queryParams) {
        console.log(queryParams);
        const params = new HttpParams()
            .set("page", page.toString())
            .set("pageSize", pageSize.toString())
            .set("queryParams", JSON.stringify(queryParams));
        return this.makeGetRequest(this.endpointMyPlans, params);
    }
    getPlansByQueryParams(page, pageSize, queryParams) {
        const params = new HttpParams()
            .set("page", page.toString())
            .set("pageSize", pageSize.toString())
            .set("queryOptions", JSON.stringify(queryParams));
        return this.makeGetRequest(this.endpointQueryParams, params);
    }
    getMediasByPlanId(planId, page, pageSize, queryParams) {
        const params = new HttpParams()
            .set("page", page.toString())
            .set("pageSize", pageSize.toString())
            .set("queryParams", JSON.stringify(queryParams));
        return this.makeGetRequest(`${this.endpointMediaPlans}/${planId}`, params);
    }
    updatePlan(planId, requestBody) {
        return this.makePatchRequest(`${this.endpointPlans}/${planId}`, requestBody);
    }
    deletePlan(planId) {
        return this.makeDeleteRequest(`${this.endpointPlans}/${planId}`);
    }
    getPlanById(planId) {
        return this.makeGetRequest(`${this.endpointPlans}/${planId}`);
    }
    getMediaPlanCount(planId) {
        return this.makeGetRequest(`${this.endpointMediaPlans}/${planId}/count`);
    }
    savePlan(request) {
        return this.makePostRequest(this.endpointPlans, request);
    }
    sharePlan(planId, request) {
        return this.makePostRequest(`${this.endpointPlans}/share/${planId}`, request);
    }
    updateMedia(mediaId, request) {
        return this.makePatchRequest(`${this.endpointMedia}/${mediaId}`, request);
    }
    getPlansByUserIdAndProjectId(userId, projectId, page, pageSize) {
        const params = new HttpParams()
            .set("page", page.toString())
            .set("pageSize", pageSize.toString());
        const url = `${this.options.API_KAZAPLAN_V41}/plans/userId/${userId}/projectId/${projectId}`;
        return this.makeGetRequest(url, params);
    }
    getPlansByProjectId(projectId, page, pageSize, userId, sort) {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());
        if (userId) {
            params = params.set('userId', userId);
        }
        if (sort && sort.length > 0) {
            params = params.set('sort', JSON.stringify(sort));
        }
        const url = `${this.endpointProjects}/${projectId}`;
        return this.makeGetRequest(url, params);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i3.CookieService }, { token: KAZAPLAN_STORAGE_KEY }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i3.CookieService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [KAZAPLAN_STORAGE_KEY]
                }, {
                    type: Inject,
                    args: [KAZAPLAN_STORAGE_KEY]
                }] }]; } });

// import { MediaApiModule } from '../media';
const WEB_SERVICES = [
    KazaPlanService
];
class KazaPlanApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: KazaPlanApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                    // TODO : vérifier que nécessaire
                    // MediaApiModule,
                    ],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { KazaPlanApiModule, KazaPlanService };
